import { render, staticRenderFns } from "./ConfiguracionAlianza.vue?vue&type=template&id=2f6d3bb5"
import script from "./ConfiguracionAlianza.vue?vue&type=script&lang=js"
export * from "./ConfiguracionAlianza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports